import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Services() {
  const services = [
    {
      title: 'Customer Notifications',
      icon: '📱',
      description: 'Send appointment reminders and service updates with A2P 10DLC compliance',
      features: [
        'Appointment reminders',
        'Service notifications',
        'Account alerts',
        'Order updates',
        'Opt-in/opt-out management'
      ]
    },
    {
      title: 'Email Communications',
      icon: '📧',
      description: 'Transactional emails and customer service messages',
      features: [
        'Transactional emails',
        'Account notifications',
        'Customer service messages',
        'Automated workflows',
        'Delivery analytics'
      ]
    },
    {
      title: 'Communication Management',
      icon: '📊',
      description: 'Streamlined customer communication workflows',
      features: [
        'Multi-channel messaging',
        'Customer segmentation',
        'Delivery tracking',
        'Compliance monitoring',
        'Message scheduling'
      ]
    },
    {
      title: 'Compliance Services',
      icon: '✓',
      description: 'Stay compliant with TCPA, CTIA, and carrier regulations',
      features: [
        'A2P 10DLC registration',
        'Consent management',
        'Compliance audits',
        'Legal documentation',
        'Carrier vetting'
      ]
    },
    {
      title: 'API Integration',
      icon: '🔌',
      description: 'Seamless integration with your existing systems',
      features: [
        'RESTful API access',
        'Webhook support',
        'CRM integration',
        'Custom development',
        'Technical support'
      ]
    },
    {
      title: 'Analytics & Reporting',
      icon: '📈',
      description: 'Comprehensive insights into campaign performance',
      features: [
        'Real-time dashboards',
        'Custom reports',
        'Conversion tracking',
        'ROI analysis',
        'Export capabilities'
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>Services - RMQ Digital</title>
        <meta name="description" content="Explore RMQ Digital's comprehensive customer communication services. A2P 10DLC compliant notifications, API integration, and expert support." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Our Services</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Secure and compliant customer communication solutions for your business</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        {/* Services Hero Image */}
        <div style={{ marginBottom: '4rem', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.1)' }}>
          <img 
            src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=400&fit=crop" 
            alt="Business analytics and communication" 
            style={{ width: '100%', height: '400px', objectFit: 'cover' }}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem' }}>
          {services.map((service, idx) => (
            <div key={idx} style={{
              background: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              padding: '2rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{service.icon}</div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.75rem' }}>
                {service.title}
              </h3>
              <p style={{ color: '#6b7280', marginBottom: '1.5rem', lineHeight: '1.6' }}>
                {service.description}
              </p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {service.features.map((feature, fidx) => (
                  <li key={fidx} style={{ 
                    color: '#4b5563', 
                    marginBottom: '0.5rem',
                    paddingLeft: '1.5rem',
                    position: 'relative'
                  }}>
                    <span style={{ 
                      position: 'absolute', 
                      left: 0, 
                      color: '#6d28d9',
                      fontWeight: '600'
                    }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ 
          background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)',
          color: 'white',
          padding: '3rem',
          borderRadius: '12px',
          textAlign: 'center',
          marginTop: '4rem'
        }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '1rem' }}>
            Need a Custom Solution?
          </h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: 0.95 }}>
            We can tailor our services to meet your specific business needs
          </p>
          <a href="/contact" style={{
            display: 'inline-block',
            background: 'white',
            color: '#6d28d9',
            padding: '1rem 2.5rem',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '1.1rem',
            transition: 'all 0.3s ease'
          }}>
            Contact Us
          </a>
        </div>
      </div>
    </>
  );
}
